import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Cell } from "../cells/cells.entity";
import { Level } from "../level/level.entity";
import { Rack } from "../racks/racks.entity";

@Entity('rack_cell_map')
export class RackCellMap {

  @PrimaryGeneratedColumn("increment",{name:'rack_cell_map_id'})
  rackCellMapId:number;
 
  @Column("varchar",{
      nullable:false,
      length:20,
      name:"rack_id"
      })
      rackId:number;

    @Column("varchar",{
      nullable:false,
      length:20,
      name:"cell_id"
      })
      cellId:number;

      @Column("varchar",{
        nullable:false,
        length:20,
        name:"level_id"
        })
        levelId:number;
     
      @Column("varchar",{
          nullable:false,
          length:20,
          name:"zone_id"
          })
          zoneId:number;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
 
  // @ManyToOne(type => Rack, rack => rack.racksinfo)
  // racks: Rack;
  @ManyToOne(type => Cell, cell => cell.cellinfo)
    cells: Cell;
  @ManyToOne(type => Level, level => level.levelinfo)
  levels: Level;

}
